<!--
 * @Author: wangyan1
 * @Description: 小组与学员
 * @Date: 2022-04-21 15:20
 * @LastEditTime: 2024-09-18 20:34:37
 * @FilePath: /teacher-xkh/src/views/groupManage/index.vue
-->
<template>
  <div class="page-group-list">
    <div class="group-list-tabs">
      <!-- <div class="f16 cg1 fbold mar32">
        我的小组
      </div> -->
      <div class="tabs-btns">
        <a-button v-gdd-hide type="primary" @click="handleCreateStudent">
          添加新学员
        </a-button>
        <a-button type="primary" style="margin: 0 8px;" @click="handleCreateGroup">
          新建小组
        </a-button>
        <a-button @click="handleHideGroupList" class="ant-btn-secondary">
          隐藏小组列表
        </a-button>
      </div>
    </div>
    <div class="table-wrapper">
      <div class="table-filter">
        <div class="filter">
          <a-input
            placeholder="搜索小组名称"
            style="width: 130px"
            class="filter-selection"
            allow-clear
            v-model="searchGroupName"
          />
          <a-input
            placeholder="学习机课程名称"
            style="width: 144px"
            class="filter-selection"
            allow-clear
            v-model="searchItvCourseName"
          />
          <template>
            <span>学年学期   </span>
            <YearSemesterSelect class="rt4" ref="yearAndSemester" @updateYearAndSemester="updateYearAndSemester" />
          </template>
          <template>
            <span>期次   </span>
            <a-select class="select rt4" :value="activePeriod" @change="(val) => selectionChange(val, 'Period')">
              <a-select-option :value="item.id" v-for="item in periodList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span>周期   </span>
            <a-select class="select rt4" v-model="activeClassCycle" @change="(val) => selectionChange(val, 'ClassCycle')">
              <a-select-option :value="item.id" v-for="item in classCycleList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span>时段   </span>
            <a-select class="select rt4" v-model="activeTimeInterval" @change="(val) => selectionChange(val, 'TimeInterval')">
              <a-select-option :value="item.id" v-for="item in timeIntervalList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <a-input
            placeholder="学生姓名/手机号"
            style="width: 146px"
            class="filter-selection"
            allow-clear
            v-model="searchStuKeyword"
          />
          <template>
            <a-button type="primary" style="margin-right: 4px;" @click="doSearch">
              搜索
            </a-button>
          </template>
          <template>
            <a-button @click="doReset" class="ant-btn-secondary">
              重置
            </a-button>
          </template>
        </div>
      </div>
      <div class="list-box">
        <div class="group-list-box">
          <a-table
            :table-layout="auto"
            :scroll="{x: 760}"
            :loading="loading"
            :columns="columns"
            :data-source="groupList"
            :pagination="false"
            :custom-row="customRowFun"
            :row-class-name="rowClassName"
            row-key="id"
          >
            <!-- <span slot="index" slot-scope="text">{{ text }}</span> -->
            <span slot="groupName" class="plan-name text-limit" slot-scope="text, record" :title="text">
              <a-tooltip placement="top">
                <template slot="title">
                  小组ID-: {{ record.id }}
                </template>
                <span class="name-desc">{{ text }}</span>
              </a-tooltip>
              <TextTagNew v-if="record.sourceType && record.sourceType === 2" class-name="yellow" words="课程升级Pro版" />
            </span>
            <span slot="studentNum" class="text-num" slot-scope="text">{{ text }}</span>

            <span slot="courseTime" class="title-dom">
              时间
            </span>
            <span slot="openTime" slot-scope="text, record">
              {{ record | formatTimeStr }}
            </span>
            <div slot="itvCourseName" slot-scope="text, record" :title="text" class="text-itv-name">
              <span class="text-limit">{{ text }}</span>
              <i v-if="record.experience === 1">体验课</i>
            </div>
            <span slot="semester" slot-scope="text, record">
              {{ record.year > 0 && record.semester ? (record.year + ' ' + record.semester) : '--' }}
            </span>
            <span slot="periodStr" slot-scope="text, record">{{ record.periodStr || '--' }}</span>
            <span slot="classCycleStr" slot-scope="text, record" :title="text">{{ record.classCycleStr || '--' }}</span>
            <span slot="timeIntervalStr" slot-scope="text, record" :title="text">{{ record.timeIntervalStr || '--' }}</span>
            <!-- 操作按钮 -->
            <span slot="action" slot-scope="text, record">
              <a-button type="t-link" @click="handleEditGroup(record)">
                编辑
              </a-button>
              <a-button style="margin-left: 8px;color: #FF8800;" type="t-link" @click="handleHideGroup(record)">
                隐藏
              </a-button>
            </span>
          </a-table>
          <div class="pagination">
            <a-pagination
              v-show="pagination.total > 0"
              v-model="pagination.current"
              :total="pagination.total"
              :page-size="pagination.pageSize"
              @change="handleChangePageNum"
            />
          </div>
        </div>
        <div class="student-list-box">
          <stu-list
            ref="studentList"
            :group-info="selectGroupInfo"
            :xkh-teacher-course-id="xkhTeacherCourseId"
          />
        </div>
      </div>
    </div>
    <create-student
      v-if="createStudentVisible"
      :visible.sync="createStudentVisible"
      @addStudentSuccess="getGroupList"
    />
    <GroupManageModal
      :visible.sync="modalVisible"
      :show-course="showCourse"
      :group-info="selectGroupInfo"
      @onSuccess="handleAddGroupSuccess"
    />
    <HideGroup
      :visible.sync="hideVisible"
      @updateList="getGroupList"
      v-if="hideVisible"
    />
  </div>
</template>

<script>
import GroupManageModal from '@/components/GroupManageModal/index.vue'
import createStudent from '@/components/createStudent/index.vue'
import YearSemesterSelect from '@/components/YearSemesterSelect.vue'
import stuList from '../students/index.vue'
import mixins from '@/utils/mixins'
import groupStudentLogger from '@/utils/logger/groupStudent.js'
import HideGroup from '../components/hideGroupList.vue'
import TextTagNew from '@/components/TextTagNew.vue'
import moment from 'moment'
// import { debounce } from 'lodash'
// 小组列表
const columns = [
  {
    dataIndex: 'groupName',
    key: 'groupName',
    title: '小组名称',
    scopedSlots: { customRender: 'groupName' },
    width: 130
  },
  {
    dataIndex: 'studentNum',
    key: 'studentNum',
    title: '人数',
    scopedSlots: { customRender: 'studentNum' },
    width: 50
  },
  {
    slots: { title: 'courseTime' },
    scopedSlots: { customRender: 'openTime' },
    width: 110
  },
  {
    dataIndex: 'itvCourseName',
    key: 'itvCourseName',
    title: '学习机课程名称',
    scopedSlots: { customRender: 'itvCourseName' },
    width: 120
  },
  {
    title: '学年学期',
    scopedSlots: { customRender: 'semester' },
    width: 80
  },
  {
    title: '期次',
    scopedSlots: { customRender: 'periodStr' },
    width: 80
  },
  {
    scopedSlots: { customRender: 'classCycleStr' },
    title: '周期',
    width: 80
  },
  {
    scopedSlots: { customRender: 'timeIntervalStr' },
    title: '时段',
    width: 50
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
    width: 120
  }
]
export default {
  mixins: [mixins],
  components: {
    stuList,
    createStudent,
    GroupManageModal,
    YearSemesterSelect,
    HideGroup,
    TextTagNew
  },
  data() {
    return {
      studentList: [], // 组内学生列表
      stuPagination: {
        pageSize: 10,
        total: 0,
        current: 1
      },
      correctionList: [], // 被打回 被打回待订正 评优
      modalVisible: false, // 新建小组控制

      columns,
      searchGroupName: '',
      searchItvCourseName: '',
      searchStuKeyword: '', // 姓名手机号
      groupList: [], // 我的小组列表
      currentGroup: {}, // 当前查看的小组信息
      stuLoading: false,
      loading: false,
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      },
      showCourse: true, // 显示课程
      xkhTeacherCourseId: -1,
      createStudentVisible: false, // 创建学员
      classTypeId: -1, // 学习机课程ID
      year: '',
      semester: '',
      selectGroupId: 0, // 被选中行的组id
      selectGroupInfo: {}, // 被选中的组信息

      subjectId: 0,
      gradeId: 0,
      visible: false,
      studentModalVisible: false,
      planInfo: {},
      searchKey: '',
      copyModalVisible: false,
      hideVisible: false // 隐藏小组列表
    }
  },
  computed: {
    getPopupContainer() {
      return () => document.querySelector('.page-group-list')
    }
  },
  filters: {
    formatTimeStr(record) {
      if (record.beginTime.indexOf('1970') !== -1 ||
      record.beginTime.indexOf('1970') !== -1) {
        return '--'
      }
      return `${moment(record.beginTime).format('YYYY.MM.DD')}-${moment(record.endTime).format('YYYY.MM.DD')}`
    }
  },
  methods: {
    nomalFormat(key) {
      console.log('nomalFormat', key)
      return key || '--'
    },
    handleChangePageNum(current, pageSize) {
      console.log('handleChangePageNum', current)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getGroupList()
    },
    /**
     * 行点击查询数据
     */
    customRowFun(record) {
      return {
        on: {
          click: evt => {
            console.log('customRowFun', evt)
            this.xkhTeacherCourseId = record.id
            this.selectGroupInfo = record

            this.getGroupStudentList()
          }
        }
      }
    },
    /**
     * 选中项的样式
     */
    rowClassName(record, index) {
      const { id } = record
      return id === this.xkhTeacherCourseId ? 'row-select' : ''
    },
    handleGroupRowsSelect() {

    },
    updateYearAndSemester(opts) {
      this.year = opts.year === '全部' ? '' : opts.year
      this.semester = opts.semester === '全部' ? '' : opts.semester
    },
    /**
     * 小组搜索
     */
    doSearch() {
      this.pagination.current = 1
      this.getGroupList()
    },
    // 重置筛选信息
    doReset() {
      this.searchGroupName = ''
      this.searchItvCourseName = ''
      this.$store.commit(`common/setActivePeriod`, -2)
      this.$store.commit(`common/setActiveTimeInterval`, -1)
      this.$store.commit(`common/setActiveClassCycle`, -1)
      this.searchStuKeyword = ''
      this.activeClassCycle = ''
      this.$refs.yearAndSemester.clearSelect()
      // this.year = '';
      // this.semester = '';
      console.log('重置')
      this.getGroupList()
    },
    selectionChange(val, key) {
      this.$store.commit(`common/setActive${key}`, val)
    },
    // 通用下拉框值变换处理
    handleSelectChange(val, selOptions, chengeKey) {
      this.$store.commit(`groupDetails/set${chengeKey}`, val)
    },
    /**
     * 小组创建成功
     */
    handleAddGroupSuccess() {
      this.getGroupList()
    },
    /**
     * 编辑小组
     */
    handleEditGroup(record) {
      // TODO
      this.selectGroupInfo = record
      this.modalVisible = true
    },
    /**
     * 隐藏小组
     */
    handleHideGroup(record) {
      this.$confirm({
        title: '您确定隐藏该小组吗？',
        content: '确定后，该小组的相关信息将不在教师端中展示(不会影响学生端展示)，您可以在"隐藏小组列表"中将小组恢复展示。',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$service.groupManage.hideGroup({ groupId: record.id, status: 1 }).then(res => {
            this.$message.success('操作成功')
            this.getGroupList()
          })
        }
      })
    },
    /**
     * 添加新学员
     */
    handleCreateStudent() {
      console.log('this.createStudentVisible', this.createStudentVisible)
      this.createStudentVisible = true
    },
    /**
     * 创建小组
     */
    handleCreateGroup() {
      groupStudentLogger.addGroupLogger({ insId: this.$store.state.userInfo.userInfo.institutionId })
      this.selectGroupInfo = {}
      this.modalVisible = true
    },
    /**
     * 隐藏小组
     */
    handleHideGroupList() {
      this.hideVisible = true
    },
    /**
     * @description 搜索课程
     */
    // onCourseSearch: debounce(function(val) {
    //   this.getCourseList(val)
    // }, 500, { leading: false }),
    /**
     * @description 课程列表
     */
    // getCourseList(courseName) {
    //   const param = { itvCourseName: courseName || '' }
    //   this.$service.courseAndGroup.getCourseListByName(param).then(res => {
    //     this.courseList = (res || []).map(item => ({
    //       id: `${item.classTypeId}`,
    //       name: item.itvCourseName
    //     }))
    //   })
    // },
    getNameById(list, id) {
      const data = list.find(item => item.id === id)
      return data ? data.name : ''
    },
    /**
     * 获取组内学生列表
     */
    getGroupStudentList() {
      // TODO
      console.log('group-获取组内学生列表')
      this.xkhTeacherCourseId !== -1 && this.$refs.studentList.getGroupStudentList({ xkhTeacherCourseId: this.xkhTeacherCourseId, keyWords: this.searchStuKeyword })
    },
    // 设置默认为null
    setNomalVal(val) {
      return val === -1 ? null : val
    },
    /**
     * 获取我的小组列表
     */
    getGroupList() {
      this.loading = true
      this.clearGroupList()
      this.$refs.studentList.clearStudentList()
      const searchParams = {
        keyWords: (this.searchStuKeyword).trim(),
        timeInterval: this.activeTimeInterval || -1,
        classCycle: this.activeClassCycle || -1,
        period: this.activePeriod,
        groupName: (this.searchGroupName).trim(),
        itvCourseName: (this.searchItvCourseName).trim(),
        year: this.year,
        semester: this.semester,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        hideStatus: 0 // 0未隐藏，1已隐藏
      }

      this.$service.groupManage.getGroupList(searchParams)
        .then(res => {
          this.loading = false
          this.pagination = {
            ...this.pagination,
            total: res.itemTotal,
            current: res.pageNum
          }
          res.list.forEach((item, index) => {
            item.index = this.pagination.total - (this.pagination.current - 1) * this.pagination.pageSize - index
          })
          this.groupList = res.list
          if (this.groupList.length > 0) {
            this.xkhTeacherCourseId = this.groupList[0].id
            this.selectGroupInfo = { ...this.groupList[0] }
          }
          // console.log('获取我的小组列表', this.xkhTeacherCourseId)
          this.getGroupStudentList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearGroupList() {
      // this.pagination.total = 0
      // this.pagination.current = 1
      this.groupList = []
      this.xkhTeacherCourseId = 0
      this.selectGroupInfo = {}
    },
    /**
     * 搜索
     */
    handleSearch() {
      this.pagination.current = 1
      this.getGroupList()
    },
    /**
     * 翻页事件
     */
    onPageChange(page) {
      this.pagination.current = page
      this.getGroupList()
    },
    /**
     * pageSize变化事件
     */
    onShowSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getGroupList()
    },
    /**
     * 切换科目
     */
    handleChangeSubject(val) {
      this.gradeId = 0
      this.pagination.current = 1
      // this.getPlanGradeList()
      this.getGroupList()
    },
    /**
     * 切换年级
     */
    handleChangeGrade() {
      this.pagination.current = 1
      this.getGroupList()
    }
  },
  mounted() {
    groupStudentLogger.initPageLogger()
    this.getGroupList()
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
:deep(.ant-popover-inner-content) {
  padding: 6px 0;

  .action-btn {
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    cursor: pointer;
    &:hover {
      background: #F5F7F9;
    }

    a {
      display: block;
      color: #505873;

      &:hover {
        color: #505873;
      }
    }
  }
}

.page-group-list {
  height: 100%;
  padding: 24px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  .filter-selection {
    margin-right: 4px;
  }
  .rt4 {
    margin-right: 4px;
  }
  .select {
    width: 80px;
  }
  .group-list-tabs{
    display: flex;
    justify-content: space-between;
    line-height: 50px;
    // margin: 0 20px;
  }
  .table-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-10;

    .table-filter {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      justify-content: space-between;

      .filter-title {
        margin-right: 12px;
      }

      .filter-title:not(:first-child) {
        margin-left: 20px;
      }
    }
    .list-box {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
    }
    .group-list-box {
      flex: 1;
      min-width: 500px;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding-right: 10px;
      .table {
        flex: 1;
        overflow: auto;
      }
      .pagination {
        text-align: right;
        padding-top: 12px;
      }
    }
    .student-list-box {
      // flex: 1;
      min-widh: 400px;
      max-width: 680px;
      border-left: 1px solid #e0e0e0;
      overflow-y: scroll;
    }
    .ant-table-wrapper {
      max-height: calc(100% - 68px);
      height: calc(100% - 68px);
      overflow: auto;
      :deep(tr) {
        line-height: 32px;
        .ant-table-row-cell-break-word {
          position: relative;
          overflow: hidden;
        }
        .text-num{
          display: block;
          text-align: center;
        }
        .text-limit1 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text-limit {
          padding: 0px 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .plan-name{
          height: 100%;
          padding: 10px 4px;
        }
        .name-desc {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .yellow {
          right: 4px;
          top: 0px;
        }

        .text-itv-name {
          position: relative;
          i {
            position: absolute;
            font-size: 10px;
            right: 0;
            top: -11px;
            background: #3262FD;
            border-radius: 0px 0px 0px 4px;
            color: #fff;
            display: inline-block;
            line-height: 1;
            padding: 2px 4px;
          }
        }
      }

      :deep(.row-select) {
        background: #F1F7FF !important;
        td {
          background: #F1F7FF !important;
        }
      }

      .plan-name {
        min-width: 122px;
      }

      .action {
        display: flex;
        a {
          margin-right: 16px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

  }

  .pagination {
    // position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 72px;
    background-color: white;
    padding-right: 18px;
  }

}
// .action-btns-wrap {
//   display: flex;
//   padding: 4px 0;
//   .action-btns-item {
//     &:hover {
//       .iconfont {
//         &::before {
//           content: '\e6ce'
//         }
//       }
//     }
//   }
// }
</style>
